import React from 'react';
import { ExternalLink } from 'lucide-react';
export type SourceKind = 'oficial' | 'orientacion' | 'config' | 'probado';
const LABELS: Record<SourceKind, string> = {
  oficial: 'Referencia oficial · Webzen',
  orientacion: 'Orientación de desarrollo · no comprobada en Vanguard',
  config: 'Confirmado por configuración de Vanguard · 08/10/2026',
  probado: 'Comprobado en Vanguard'
};
export function SourceTag({
  kind,
  href
}: {
  kind: SourceKind;
  href?: string;
}) {
  const cls = 'inline-flex items-center gap-1 text-xs text-gray-500';
  if (href) return <a href={href} target="_blank" rel="noreferrer" className={`${cls} hover:text-[#D4AF37]`} data-id="element-403" data-mp="1rflz9n73l446">
        {LABELS[kind]} <ExternalLink className="h-3 w-3" aria-hidden="true" data-id="element-404" data-mp="1hng82foo6qq1" />
      </a>;
  return <span className={cls} data-id="element-405" data-mp="1hldi1vnioxlb">{LABELS[kind]}</span>;
}